import NewClientContract from './NewClientContract';

export default NewClientContract;
